var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsZoomOutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5L15.514 16.006M12 10H7M18 10C18 12.2543 17.1045 14.4163 15.5104 16.0104C13.9163 17.6045 11.7543 18.5 9.5 18.5C7.24566 18.5 5.08365 17.6045 3.48959 16.0104C1.89553 14.4163 1 12.2543 1 10C1 7.74566 1.89553 5.58365 3.48959 3.98959C5.08365 2.39553 7.24566 1.5 9.5 1.5C11.7543 1.5 13.9163 2.39553 15.5104 3.98959C17.1045 5.58365 18 7.74566 18 10Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsZoomOutWhite);
export default __webpack_public_path__ + "static/media/akar-icons_zoom-out-white.328084e02f0ef856971d0cea1a8722ea.svg";
export { ForwardRef as ReactComponent };